import {PcsSubjectElementType} from "../interface";
import DisplayNumber from "../../../../../components/common/number/DisplayNumber";

interface PropsType {
    pcsSubject: PcsSubjectElementType[]
    menuTitleText: string
}

export default function Tab2({pcsSubject, menuTitleText}: PropsType) {
    return <div className="content_wrap">
        <div className="table_top">
            <h6 className="table_stats">{menuTitleText}품목</h6>
            <div className="table_toolbar">
            </div>
        </div>
        <div className="table_scroll mb-0">
            <table className="table table-bordered my_table table_detail">
                <thead>
                <tr>
                    <th style={{width: "10.5%"}}>제품군</th>
                    <th style={{width: "29.4%"}}>품목</th>
                    <th style={{width: "18.8%"}}>규격</th>
                    <th style={{width: "10.5%"}}></th>
                    <th style={{width: "16.4%"}}></th>
                    <th>수량</th>
                </tr>
                </thead>
                <tbody>
                {pcsSubject.map(el =>
                    <tr>
                        <td className="text-center">{el.productGroupName}</td>
                        <td>{el.productName}</td>
                        <td className="text-center">{el.newTxtStandard}</td>
                        <td className="text-center"></td>
                        <td className="text-center"></td>
                        <td className="text-end"><DisplayNumber value={el.newIQty}/></td>
                    </tr>
                )}
                </tbody>
                <tfoot>
                <tr>
                    <td className="text-start grey" colSpan={5}></td>
                    <td className="text-end"><DisplayNumber
                        value={pcsSubject.reduce((acc, cur) => acc + cur.newIQty, 0)}/></td>
                </tr>
                </tfoot>
            </table>
        </div>
    </div>
}